import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

export default class WrappedSearchFilter extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      active: props.active
    }
    this.onClickBound = this.onClick.bind(this)
    this.onBlurBound = this.onBlur.bind(this)
  }

  render () {
    const { disabled, area } = this.props
    return (
      <div
        className={`area ${area}-wrapper ${this.state.active ? 'active' : ''} ${
          disabled ? 'disabled' : ''
        }`}
        onMouseDown={this.onClickBound}
        onBlur={this.onBlurBound}
        data-for={`${area}-filter-tooltip`}
        data-tip={this.props.disabledText}
      >
        {disabled && <ReactTooltip id={`${area}-filter-tooltip`} />}
        <label className="header h5">{this.props.label}</label>
        {disabled ? null : this.props.children}
      </div>
    )
  }

  onClick () {
    this.setState(() => {
      return {
        active: true
      }
    })
    if (!this.state.active) {
      setTimeout(() => {
        this.props.wrappedRef.current.focus()
      }, 100)
    }
  }

  onBlur () {
    this.setState(() => {
      return {
        active: this.props.active
      }
    })
  }
}

WrappedSearchFilter.propTypes = {
  area: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.object,
  wrappedRef: PropTypes.object,
  disabled: PropTypes.bool,
  disabledText: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/HOC/WrappedSearchFilter.js